import React from "react";
import Modal from "@mui/material/Modal";
import "./EmailBodyModal.scss";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";

function EmailBodyModal({ open, handleClose, email }) {
  function htmlDecode(input) {
    let doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent;
  }
  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="email-container-modal"
        style={{
          position: "fixed",
          //   transform: "translate(116px, 96px)",
          zIndex: 9999,
          display: "flex",
          //   alignItems: "center",
          //   justifyContent: "center",
          //   width: "80%",
        }}
      >
        <div className="centered-content">
          {/* Close button */}
          <IconButton
            onClick={handleClose}
            style={{
              position: "absolute",
              top: 10,
              right: 10,
              zIndex: 9999,
              color: "black",
            }}
          >
            <CloseIcon />
          </IconButton>
          <div dangerouslySetInnerHTML={{ __html: htmlDecode(email) }} />
        </div>
      </Modal>
    </div>
  );
}

export default EmailBodyModal;
